export const schema = {
  schema: {
    type: "object",
    properties: {
      name: {
        type: "string",
        description: "Name of the individual.",
      },
      summary: {
        type: "string",
        description:
          "The summary of the individual if present in the resume. If the summary is not present, generate a summary based on the individual's resume.",
      },
      contact_information: {
        type: "object",
        description: "Contact details of the individual.",
        properties: {
          portfolio: {
            type: ["string", "null"],
            description:
              "Link to the individual's portfolio website. Read and extract if any active URL present. The output must be a URL.",
          },
          linkedin: {
            type: ["string", "null"],
            description:
              "Link to the individual's LinkedIn profile. Read and extract if any active URL present. The output must be a URL.",
          },
          phone_number: {
            type: ["string", "null"],
            description: "Phone number of the individual.",
          },
          email: {
            type: ["string", "null"],
            description: "Email address of the individual.",
          },
          github: {
            type: ["string", "null"],
            description:
              "Link to the individual's Github profile. Read and extract if any active URL present. The output must be a URL.",
          },
          address: {
            type: ["string", "null"],
            description:
              "The address of the individual mentioned in the resume.",
          },
        },
      },
      languages: {
        type: "array",
        description: "List of all the languages that the individual can speak.",
        items: {
          type: "object",
          properties: {
            name: {
              type: "string",
              description:
                "The name of the language (Eg. English, French, etc.)",
            },
            fluency: {
              type: "enum",
              description:
                "The level of fluency that the individual has in the language.",
              enum: ["NOVICE", "INTERMEDIATE", "FLUENT", "NATIVE_SPEAKER"],
            },
          },
        },
      },
      work_experience: {
        type: "array",
        description: "List of work experiences that the individual has.",
        items: {
          type: "object",
          properties: {
            experience_type: {
              type: "enum",
              enum: [
                "FULL_TIME",
                "PART_TIME",
                "INTERNSHIP",
                "FREELANCE",
                "OTHER",
              ],
              description:
                "The type of the experience the individual has achieved.",
            },
            company: {
              type: "string",
              description: "Name of the company.",
            },
            position: {
              type: "string",
              description: "Job title held at the company.",
            },
            skills_used: {
              type: "array",
              description:
                "List of all the skills / technologies used in the role.",
              items: {
                type: "string",
              },
            },
            location: {
              type: "string",
              description: "Location of the work experience.",
            },
            date_range: {
              type: "string",
              description:
                "Date range of employment. Format should always be (MM/YYYY-MM/YYYY).",
            },
            is_current: {
              type: "boolean",
              description: "Denotes if the individual is still working here.",
            },
            responsibilities: {
              type: "array",
              description: "List of responsibilities held in the role.",
              items: {
                type: "string",
              },
            },
          },
        },
      },
      work_experience_years: {
        type: "float",
        description:
          "The total number of years that the individual worked. Calculate this based on the work_experience provided in the resume.",
      },
      education: {
        type: "array",
        description: "List of all the education that the individual has.",
        items: {
          type: "object",
          properties: {
            institute_type: {
              type: "enum",
              enum: ["COLLEGE", "UNIVERSITY", "OTHER"],
              description: "Whether the institute is a college or university",
            },
            institute_name: {
              type: "string",
              description: "Name of the college or university.",
            },
            degree_type: {
              type: "enum",
              enum: ["BACHELORS", "MASTERS", "PG DIPLOMA", "PHD"],
              description:
                "Type of the degree that the individual has attained.",
            },
            degree_name: {
              type: "string",
              description:
                "Name of the degree that the individual has achieved.",
            },
            designation: {
              type: "string",
              description:
                "The designation or the field in which the individual has achieved the education.",
            },
            score: {
              type: "float",
              description:
                "The score that the individual has achieved during that education.",
            },
            out_of: {
              type: "float",
              description:
                "The total score out of which the above score was extracted.",
            },
            location: {
              type: "string",
              description: "Location of the Institute.",
            },
            date_range: {
              type: "string",
              description:
                "Date range of employment. Format should always be (MM/YYYY-MM/YYYY).",
            },
            courses: {
              type: "array",
              description:
                "List of all the courses the individual attended during the education if mentioned.",
              items: {
                type: "object",
                properties: {
                  name: {
                    type: "string",
                    description: "Name of the course.",
                  },
                  description: {
                    type: "string",
                    description: "Description of the course.",
                  },
                },
              },
            },
          },
        },
      },
      education_years: {
        type: "number",
        description:
          "The total number of years that the individual has attended any educational institute. Calculate this based on the years of education that the individual has mentioned.",
      },
      projects: {
        type: "array",
        description: "List of projects that the individual has worked on.",
        items: {
          type: "object",
          properties: {
            name: {
              type: "string",
              description: "Name of the project.",
            },
            course_details: {
              type: ["string", "null"],
              description: "Course details related to project.",
            },
            skills: {
              type: ["array", "null"],
              description: "List of hard skills used in the project.",
              items: {
                type: "string",
              },
            },
            description: {
              type: ["string", "null"],
              description: "Project description",
            },
            location: {
              type: "string",
              description: "Location of the project.",
            },
            date_range: {
              type: "string",
              description:
                "Date range of the project. Format should always be (MM/YYYY-MM/YYYY).",
            },
          },
        },
      },
      hobbies: {
        type: "array",
        description:
          "List of all the hobbies that the individual has mentioned in the resume.",
        items: {
          type: "string",
        },
      },
      certifications: {
        type: "array",
        description:
          "List of all the certifications that the individual has mentioned in the resume.",
        items: {
          type: "object",
          properties: {
            name: {
              type: "string",
              description:
                "The name of the certification that the inidividual has achieved.",
            },
            certified_by: {
              type: "string",
              description:
                "The name of the institute or the organization that has certified the individual.",
            },
            issued_at: {
              type: "string",
              description:
                "The date at which the certification has been issued. Format should always be (MM/YYYY).",
            },
            expiry: {
              type: "string",
              description:
                "The expiry date of the certification. Format should always be (MM/YYYY).",
            },
          },
        },
      },
      accomplishments: {
        type: "array",
        description:
          "List of all other accomplishments that the individual has achieved.",
        item: {
          type: "string",
        },
      },
      hard_skills: {
        type: "array",
        description: "List of the hard skills that the individual has.",
        items: {
          type: "object",
          properties: {
            name: {
              type: "string",
              description: "The name of the skill that the inidividual has.",
            },
            examples: {
              type: "array",
              description:
                "List of the examples in the resume where the particular hard skill is used if any.",
              items: {
                type: "object",
                properties: {
                  designation: {
                    type: ["enum", "null"],
                    enums: [
                      "WORK_EXPERIENCE",
                      "FREELANCE",
                      "PROJECT",
                      "EDUCATION",
                      "OTHERS",
                    ],
                    description:
                      "This designates where that particular hard skill was used.",
                  },
                  name: {
                    type: "string",
                    description: "Name of the designation",
                  },
                },
              },
            },
          },
        },
      },
      hard_skills_keywords: {
        type: "array",
        description:
          "List of all the keywords that are hard skills present anywhere in the resume",
        items: {
          type: "string",
        },
      },
      soft_skills: {
        type: "array",
        description:
          "List of the soft skills that the individual has. This includes leadership experience as well.",
        items: {
          type: "object",
          properties: {
            name: {
              type: "string",
              description: "The name of the skill that the inidividual has.",
            },
            examples: {
              type: "array",
              description:
                "List of the examples in the resume where the particular soft skill is used if any.",
              items: {
                type: "object",
                properties: {
                  designation: {
                    type: ["enum", "null"],
                    enums: [
                      "WORK_EXPERIENCE",
                      "FREELANCE",
                      "PROJECT",
                      "EDUCATION",
                      "OTHERS",
                    ],
                    description:
                      "This designates where that particular soft skill was used.",
                  },
                  name: {
                    type: "string",
                    description: "Name of the designation.",
                  },
                  description: {
                    type: "string",
                    description: "Description of the designation.",
                  },
                },
              },
            },
          },
        },
      },
      soft_skills_keywords: {
        type: "array",
        description:
          "List of all the keywords that are soft skills present anywhere in the resume.",
      },
      additional_fields: {
        type: "object",
        description:
          "Any additional fields not captured in the defined schema.",
      },
    },
  },
};
